import React, { useState } from 'react'
import { Label } from '@entur/typography'
import { space } from '@entur/tokens'
import { CustomFilterChip, FilterChipInfo } from './custom-filter-chip'
import { useOnlyUpdateableEffect } from '../../../hooks/common-hooks'

type TravelTypeFilterFieldProps = {
  travelTypes: string[]
  setTravelTypes: (travelTypes: string[]) => void
}

export const TravelTypeFilterField: React.FC<TravelTypeFilterFieldProps> = ({ travelTypes, setTravelTypes }) => {
  const [privateTravel, setPrivateTravel] = useState<FilterChipInfo>({
    name: 'Privat',
    value: 'privat',
    isChecked: travelTypes.includes('privat'),
  })
  const [serviceTravel, setServiceTravel] = useState<FilterChipInfo>({
    name: 'Tjeneste',
    value: 'tjeneste',
    isChecked: travelTypes.includes('tjeneste'),
  })

  useOnlyUpdateableEffect(() => {
    const travelTypes = [privateTravel, serviceTravel].filter((chip) => chip.isChecked).map((chip) => chip.value)
    setTravelTypes(travelTypes)
  }, [privateTravel, serviceTravel])

  const displayFlex = { display: 'flex', gap: space.rem.medium + 'rem' }

  return (
    <div>
      <Label>Reisetype</Label>
      <div style={displayFlex} data-cy="travel-type-filter-chips">
        <CustomFilterChip filterChipInfo={privateTravel} setFilterChipInfo={setPrivateTravel} />
        <CustomFilterChip filterChipInfo={serviceTravel} setFilterChipInfo={setServiceTravel} />
      </div>
    </div>
  )
}
